module.exports = __webpack_public_path__ + "img/home.c1af7961.svg";